import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import styles from './styles.module.css';

/** @param {typeof propTypes} props  */
function Title(props) {
    const { size = 'lg', color = 'dark', underline = false, children, className } = props;

    return (
        <div
            className={classNames(styles.root, className, styles[`size-${size}`], styles[`color-${color}`], {
                [styles.underline]: underline,
            })}
        >
            {children}
        </div>
    );
}

const propTypes = {
    size: PropTypes.oneOf(['xxl', 'xl', 'lg', 'md']),
    color: PropTypes.oneOf(['dark', 'light']),
    underline: PropTypes.bool,
    className: PropTypes.string,
};
Title.propTypes = propTypes;

export default Title;
